module.exports = __webpack_public_path__ + "static/media/shopper-helper-icon.22fb56c0.png";